/**
 * Full page navigations. After sign-in the app loads the destination fresh (`location.replace`):
 * no stale in-memory state from the signed-out app, and the login page leaves the history.
 * Kept in an object so tests (jsdom can't navigate) can replace it.
 */
export const browserLocation = {
  replace(url: string) {
    window.location.replace(url);
  },
  /**
   * A new tab opened now, inside the click (popup blockers allow it), pointed at a URL known
   * only later (e.g. a one-time link the API returns). `cancel` closes it on failure.
   */
  openPendingTab(): { go: (url: string) => void; cancel: () => void } {
    const tab = window.open("about:blank", "_blank");
    if (tab) tab.opener = null;
    return {
      go: (url) => {
        if (tab && !tab.closed) tab.location.replace(url);
        else window.open(url, "_blank", "noopener");
      },
      cancel: () => tab?.close(),
    };
  },
};
